// removed by extract-text-webpack-plugin
module.exports = {"pitch":"#282c31","spacing-small":"4px","spacing-medium":"8px","spacing-large":"16px","this":"TopicsSectionTitle__this___1507e"};


//////////////////
// WEBPACK FOOTER
// ./src/groups/components/styles/TopicsSectionTitle.css
// module id = 2329
// module chunks = 0 1